import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Typography from '@mui/material/Typography';
import {Divider} from '@mui/material';
import InfoItemBox from './InfoItemBox';
import { InfoItemBoxProps } from '../dataObjects/contentTypes';

const content: InfoItemBoxProps[] = [
  {
    title: "Commence Recordkeeping and Reporting",
    blocks: [
      {
        type: "list",
        listType: "bullet",
        items: [
          {
            content: [
              {
                type: "text",
                content: "A local party committee must file disclosure reports with OCPF if, during a reporting period, any portion of its financial activity (receipts, expenditures, in-kind contributions, liabilities, or acquiring or disposing of assets) exceeds $100. If a committee exceeds this threshold after not having filed for several periods, the report it files must include activity dating back to the last report filed. In other words, it would include the periods during which its activity did not meet the reporting threshold.",
              }
            ]
          },
          {
            content: [
              {
                type: "text",
                content: "Please visit the ",
              },
              {
                type: "link",
                text: "Filing Schedules",
                url: "/Filers/FilingSchedules", 
              },
              {
                type: "text",
                content: " page to view the Non-Depository Committees reporting schedule.",
              }
            ]
          },
          {
            content: [
              {
                type: "text",
                content: "If the committee needs to electronically file, you can log on to ",
              },
              {
                type: "link",
                text: "Reporter",
                url: "http://www.ocpfreporter.us/", 
              },
              {
                type: "text",
                content: " OCPF's online filing application.",
              }
            ]
          },
          {
            content: [
              {
                type: "text",
                content: "Candidates and committees must maintain detailed accounts of all contributions received and all expenditures made. These records must be kept separate and distinct from any other accounts or records and must be preserved for 6 years from the relevant election.",
              }
            ]
          },
        ]
      }
    ]
  },
  {
    title: "Help Videos To Get Started",
    blocks: [
      {
        type: "paragraph",
        content: [
          {
            type: "text",
            content: "We've created a ",
          },
          {
            type: "link",
            text: "playlist",
            url: "https://www.youtube.com/playlist?list=PLjg1OsRbioqD7UVWWB0r6-alJklot-75S", 
          },
          {
            type: "text",
            content: " of videos to get you started using Reporter 7. Videos include:",
          }
        ]
      },
      {
        type: "subheading",
        content:"Local Party Committees"
      },
      {
        type: "list",
        listType: "bullet",
        items: [
          
          {
            content: [
              {
                type: "link",
                text: "How To File A Non-Depository Report (including the Year-End Report)",
                url: "https://www.youtube.com/watch?v=akKs_jBM4tM", 
              }
            ]
          },
          {
            content: [
              {
                type: "link",
                text: "How To Upload Data to A Report",
                url: "https://www.youtube.com/watch?v=5wNyzDIa4B4&index=12&list=PLjg1OsRbioqD7UVWWB0r6-alJklot-75S&t=0s", 
              }
            ]
          },
        ]
      }
    ]
  },
  {
    title: "Additional Help & Information",
    blocks: [
      {
        type: "list",
        listType: "bullet",
        items: [
          {
            content: [
              {
                type: "link",
                text: "Campaign Finance Guide",
                url: "https://ocpf2.blob.core.windows.net/pdf/guides/wtc_guide_2010.pdf", 
              },
              {
                type: "text",
                content: ": Local Party Committees.",
              }
            ]
          },
          {
            content: [
              {
                type: "link",
                text: "Common errors to avoid",
                url: "https://ocpf2.blob.core.windows.net/pdf/guides/common_errors_muni.pdf",
              },
              {
                type: "text",
                content: " when filing.",
              }
            ]
          },
          {
            content: [
              {
                type: "text",
                content: "Contribution Limits ",
              },
              {
                type: "link",
                text: "Chart",
                url: "/Legal/ContributionLimits", 
              },
              {
                type: "text",
                content: ".",
              }
            ]
          },
          {
            content: [
              {
                type: "text",
                content: "Public Employees and Campaigns: ",
              },
              {
                type: "link",
                text: "A Fact Sheet",
                url: "https://ocpf2.blob.core.windows.net/pdf/guides/fs_pub_emp.pdf", 
              },
              {
                type: "text",
                content: ".",
              }
            ]
          },
          {
            content: [
              {
                type: "text",
                content: "OCPF Guide: ",
              },
              {
                type: "link",
                text: "Reporting Out-of-Pocket Campaign Expenditures",
                url: "https://ocpf2.blob.core.windows.net/pdf/guides/abd_guide_2010.pdf", 
              },
              {
                type: "text",
                content: " .",
              }
            ]
          },
        ]
      }
    ]
  }
];


const LocalLPCInfo = (): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });


  return (
      <div>
        
        <Typography
              component="h1"
              variant="h4"
              align={'left'}
              data-aos={'fade-up'}
              gutterBottom
              sx={{
                fontWeight: 700,
              }}
              paddingTop={4}>
              Local Political Party Committee: How to Prepare and File Reports
            </Typography>

            <Divider />
         {content.map((content, index) => (
          <InfoItemBox key={index} {...content} />
        ))}
      </div>
       
   
        
  );
};

export default LocalLPCInfo;
